import React from "react";
import {
  Card,
  CardContent,
  CardActionArea,
  CardActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import ProviderBadge from "../ProviderBadge";

const PostCard = ({ post, onOpenViewer, resolvePublicUrl, loadingDoc }) => {
  return (
    <Card
      elevation={0}
      variant="outlined"
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "translateY(-4px)",
          boxShadow: (theme) =>
            `0 12px 24px -10px ${alpha(theme.palette.primary.main, 0.15)}`,
          borderColor: "primary.main",
        },
        bgcolor: "background.paper",
        borderRadius: 3,
      }}
    >
      <CardActionArea
        onClick={() => onOpenViewer(post.filePath)}
        sx={{ flexGrow: 1, display: "flex", p: 1 }}
      >
        <CardContent sx={{ flexGrow: 1 }}>
          <Box
            sx={{
              mb: 1.5,
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              variant="caption"
              sx={{
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                color: "primary.main",
                fontWeight: 700,
                px: 1.5,
                py: 0.5,
                borderRadius: "12px",
                display: "inline-block",
                letterSpacing: 0.5,
                fontSize: "0.7rem",
              }}
            >
              {post.category?.toUpperCase()}
            </Typography>

            {post.providerName && (
              <ProviderBadge providerName={post.providerName} />
            )}
          </Box>

          <Typography
            variant="h6"
            color="text.primary"
            gutterBottom
            sx={{
              fontWeight: 700,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {post.title || "(Untitled Report)"}
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
            By {post.author} • {post.date}
          </Typography>

          {post.summary && (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                mt: 0.5,
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {post.summary}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>

      <CardActions
        sx={{
          mt: "auto",
          flexWrap: "wrap",
          gap: 1,
          px: 3,
          pb: 2,
        }}
      >
        <Button
          size="small"
          variant="outlined"
          color="primary"
          onClick={() => onOpenViewer(post.filePath)}
          disabled={loadingDoc}
        >
          {loadingDoc ? "Loading…" : "Preview"}
        </Button>

        {post.filePath && (
          <Button
            size="small"
            variant="contained"
            component="a"
            href={resolvePublicUrl(post.filePath)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download PDF
          </Button>
        )}
      </CardActions>
    </Card>
  );
};

// Memoize the component to prevent unnecessary re-renders
// Only re-renders when props actually change
export default React.memo(PostCard);
